export const REDUCER_NAME = 'CollateralDetails'
